import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetIndividualClientQuery } from '../../../app/Slices/SevenDayApiSlice';
import { CustomSmallListChip } from '../../../layout/styledcomponents/CustomChip';
import { CustomIconButton } from '../../../layout/styledcomponents/CustomIconButton';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import EditClientForm from '../../components/ClientManagement/Client Forms/EditClientForm';
import NewClientForm from '../../components/ClientManagement/Client Forms/NewClientForm';
import ViewIndividualClient from '../../components/ClientManagement/ViewIndividualClient';
import ConfirmationModal from '../../shared/ConfirmationModal';

export default function ClientFormPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const [url, setUrl] = useState('');
    const urlRef = window.location.href.split('/')[5];
    const { data: getIndividualClient, isFetching } =
        useGetIndividualClientQuery(url);
    const [open, setOpen] = useState(false);

    const theme = useTheme();

    useEffect(() => {
        if (urlRef !== undefined) {
            setUrl(`/owners/${urlRef}`);
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const editClient = () => {
        navigate(
            `/editClient/${getIndividualClient?.name}/${getIndividualClient?.id}`,
            {
                state: {
                    name: 'editClient',
                },
            },
        );
    };

    const onClickOpenModal = () => {
        setOpen(true);
    };
    const handleChangeModal = () => {
        setOpen(false);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    return (
        <>
            {isFetching === true ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile || isIpad ? '100%' : '80%',
                        justifyContent: 'left',
                        alignItems: 'center',
                    }}
                >
                    <Grid
                        sx={{
                            width: '100%',
                            height: isMobile || isIpad ? '2%' : '5%',
                            justifyContent: 'left',
                            display: 'flex',
                        }}
                    >
                        {window.location.href?.includes('newClient') ? (
                            <Typography
                                variant='h1'
                                sx={{
                                    textAlign: 'left',
                                    textTransform: 'uppercase',
                                }}
                            >
                                New Client
                            </Typography>
                        ) : window.location.href?.includes('client') ? (
                            <>
                                <Typography
                                    variant='h1'
                                    sx={{
                                        textAlign: 'left',
                                        textTransform: 'uppercase',

                                        paddingRight: '15px',
                                    }}
                                >
                                    {' '}
                                    {getIndividualClient?.name}
                                </Typography>
                                <Typography
                                    sx={{
                                        color: 'dark',
                                    }}
                                >
                                    <CustomSmallListChip
                                        size='small'
                                        style={{
                                            border: 0,
                                            backgroundColor:
                                                getIndividualClient?.isActive ===
                                                true
                                                    ? theme.palette.textAccent
                                                          .main
                                                    : theme.palette.lightGrey
                                                          .main,
                                            color:
                                                getIndividualClient?.isActive ===
                                                true
                                                    ? theme.palette.neutral.main
                                                    : theme.palette.midGrey
                                                          .main,
                                        }}
                                        label={
                                            getIndividualClient?.isActive ===
                                            true
                                                ? 'Enabled'
                                                : 'Disabled'
                                        }
                                        variant='outlined'
                                    />
                                </Typography>
                            </>
                        ) : (
                            <Typography
                                variant='h1'
                                sx={{
                                    textAlign: 'left',
                                    textTransform: 'uppercase',
                                }}
                            >
                                Edit Client
                            </Typography>
                        )}
                    </Grid>
                    <Grid sx={{ width: '100%', textAlign: 'right' }}>
                        {window.location.href?.includes('editClient') ||
                        window.location.href?.includes('newClient') ? null : (
                            <Grid
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Grid>
                                    {' '}
                                    <CustomIconButton
                                        disableRipple
                                        sx={{
                                            backgroundColor:
                                                theme.palette.neutral.main,
                                            width: '25px',
                                            height: '25px',
                                            paddingLeft: '20px',
                                        }}
                                        onClick={editClient}
                                    >
                                        <EditIcon
                                            fontSize='small'
                                            sx={{
                                                fontSize: '16px',
                                                '&:hover': {
                                                    cursor: 'pointer',
                                                    color: theme.palette
                                                        .textAccent.main,
                                                    backgroundColor:
                                                        'transparent',
                                                    background: 'none',
                                                },
                                            }}
                                        />
                                    </CustomIconButton>
                                </Grid>

                                <Grid>
                                    <CustomIconButton
                                        disableRipple
                                        sx={{
                                            backgroundColor:
                                                theme.palette.neutral.main,
                                            width: '25px',
                                            height: '25px',
                                        }}
                                        onClick={onClickOpenModal}
                                    >
                                        <DeleteOutlineIcon
                                            fontSize='small'
                                            sx={{
                                                fontSize: '16px',
                                                '&:hover': {
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                    backgroundColor:
                                                        'transparent',
                                                    background: 'none',
                                                },
                                            }}
                                        />
                                    </CustomIconButton>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    {window.location.href?.includes('newClient') ? (
                        <NewClientForm />
                    ) : window.location.href?.includes('editClient') ? (
                        <EditClientForm client={getIndividualClient} />
                    ) : (
                        <ViewIndividualClient />
                    )}
                </Grid>
            )}
            <ConfirmationModal
                open={open}
                onClose={handleCloseModal}
                onChange={handleChangeModal}
                message={'delete this user'}
                component={'client'}
                id={getIndividualClient?.id}
            />
        </>
    );
}
